import { Component, OnInit } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {

  constructor(private router: Router,
    private filterService: FilterService,) { }

  ngOnInit() {
  }

  analyticsPage(){
    this.filterService.analyticsSubject.next(true);
    // this.router.navigate([`analytics`]);
  }

  toggleDiv() {   
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('toggle-left-menu');
   }
}
